import { render, staticRenderFns } from "./devdoc.vue?vue&type=template&id=150daba7&scoped=true&"
import script from "./devdoc.vue?vue&type=script&lang=js&"
export * from "./devdoc.vue?vue&type=script&lang=js&"
import style0 from "./devdoc.vue?vue&type=style&index=0&id=150daba7&scoped=scoped&lang=css&"
import style1 from "./devdoc.vue?vue&type=style&index=1&id=150daba7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150daba7",
  null
  
)

export default component.exports